import { useEffect, useState } from 'react';

import { getDocument } from '@atlaskit/browser-apis';

const TOOLBAR_SELECTOR = '[data-testid="editor-floating-toolbar"]';

export const usePopupTargetElement = ({
	blockElement,
	isOpen,
}: {
	blockElement: HTMLElement | null;
	isOpen: boolean;
}): HTMLElement | null => {
	const [toolbarElement, setToolbarElement] = useState<HTMLElement | null>(null);

	useEffect(() => {
		if (!isOpen) {
			if (toolbarElement) {
				setToolbarElement(null);
			}
			return;
		}

		if (toolbarElement) {
			return;
		}

		const toolbar = getDocument()?.querySelector<HTMLElement>(TOOLBAR_SELECTOR);
		if (toolbar) {
			setToolbarElement(toolbar);
			return;
		}

		const id = requestAnimationFrame(() => {
			const el = getDocument()?.querySelector<HTMLElement>(TOOLBAR_SELECTOR);
			if (el) {
				setToolbarElement(el);
			}
		});
		return () => cancelAnimationFrame(id);
	}, [isOpen, toolbarElement]);

	return toolbarElement ?? blockElement;
};
